/**
 * Where the keypad book lives on the tablet.
 *
 * Its own key and its own version, so the panels a technician programs cannot
 * invalidate — or be invalidated by — the RCU configuration next to them.
 */
export const KEYPAD_STORAGE_KEY = 'toyama.rcu-keypads.v1';

/** Bumped whenever the stored keypad shape changes. */
export const KEYPAD_SCHEMA_VERSION = 1;
